import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
	fundersByProtocol: {},
	selectedProtocol: null,
	researchers: [],
	externalResearchers: [],
	funders: [],
	researchLines: [],
	financingCommitments: [],
	biosecurityQuestionnaire: null,
	readonly: false,
	rpbiResearchers: [],
	renewalAttachments: [],
	motherProtocol: null,
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
